import InstrumentRunner from "@/pages/portal/tools/InstrumentRunner";
import { PHQ9_ITEMS, FOUR_POINT_SCALE, interpretPHQ9 } from "@/data/instruments";

export default function PHQ9() {
  return (
    <InstrumentRunner
      kind="phq9"
      testidPrefix="phq9"
      overline="Portal · Tool"
      title="PHQ-9"
      subtitle="Patient Health Questionnaire — 9 items. Depression severity measure used at admission, weekly, and at every level-of-care transition."
      items={PHQ9_ITEMS}
      scale={FOUR_POINT_SCALE}
      interpret={interpretPHQ9}
    />
  );
}
